const isVictoriaDay = date => {
  if (date.month() === 4) {
    // It is May!
    if (date.isoWeekday() === 1) {
      // It is a monday!
      const dayOfMonth = date.date();
      if (dayOfMonth < 25 && dayOfMonth >= 18) {
        // It is victoria day!
        return true;
      }
    }
  }
  return false;
};
export default isVictoriaDay;
//# sourceMappingURL=isVictoriaDay.js.map